import { effect, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isInitialized()) {
    await new Promise<void>(resolve => {
      effect(() => {
        if (authService.isInitialized()) resolve();
      });
    });
  }

  if (authService.isAuthenticated()) return true;

  const currentUrl = new URL(window.location.href);

  if (currentUrl.pathname !== '/auth/login') {
    const redirectUrl = currentUrl.pathname + currentUrl.search + currentUrl.hash;
    router.navigate(['/auth/login'], { queryParams: { redirectUrl } });
    return false;
  }

  if (currentUrl.searchParams.has('redirectUrl')) {
    router.navigate(['/auth/login'], { queryParams: { redirectUrl: currentUrl.searchParams.get('redirectUrl') } });
    return false;
  }

  router.navigate(['/auth/login']);
  return false;
};
